/* USE PROTECTION design: the Monogram letter window (snippets/mf-monogram.liquid, the .u-panel #mono).
 * ES5 on purpose (no build step, same rule as mf-track.js). Loaded deferred by the snippet, which the menu
 * (snippets/up-menu.liquid) renders on every page.
 *
 * window.mfOpenMonogram(opts) opens the sheet through assets/up.js (window.upPanel: scrim, body lock, Escape, Tab kept
 * inside, focus back to the opener). Callers: the menu's Monogram tile (assets/up-menu.js, no opts) and the collection
 * bar's Monogram pill (sections/up-collection + assets/up-lists.js, owner 2026-10-21), which passes opts.base = the
 * device page's own path, so the sheet lists the phone on screen rather than a remembered one (live collection-v2's
 * pill called it too; collection-v2 is disabled in templates/collection.json). The pill carries data-mfm-warm: a
 * pointer or focus on it fetches the stylesheet ahead of the tap (the menu's opening does that for the tile).
 *
 * The live window's logic, kept as it was (only the look and the way to choose the letter are new):
 *   - the phone: window.mfMenuDeviceBase() (assets/up-menu.js: the remembered phone, else the device page being
 *     viewed), else the fallback collection the snippet renders; every path goes through mfHref (market prefix);
 *   - the designs: that phone's Monogram view (the snippet's data-mono-suffix) through the cards endpoint
 *     (?view=mfcards&page=N, templates/collection.mfcards.liquid, 250 cards a page), one entry per design and
 *     letter (key: the design name, plus the card's data-mono on the 2026-10-05 series), the letter read by
 *     window.mfMonoLetter(name, data-mono) (snippets/mf-l10n.liquid); a typed key is folded by mfNormLetter;
 *   - steps through mfTrackPush('mf_nav_step'): mono:open, mono:letter_<x> (when a letter's list is on screen and
 *     the letter changed - á/é/ö/ü as a2/e2/o2/u2), mono:pick (a tile tapped), mono:close (any close: X, scrim,
 *     Escape, another panel); new: mono:all (the "Vezi toate monogramele" CTA). Read against the live window with
 *     care: a tap is cheaper than typing, so mono:letter_* per opening runs higher.
 *   - the CTA lands on the phone's Monogram view, on the chosen letter when there is one (?letter=X, preselected by
 *     sections/up-collection + assets/up-lists.js - owner 2026-10-21), so it shows in the letter state too, then
 *     labelled "Vezi toate monogramele cu K". Aimed at the collection on screen it is re-rendered in place there and
 *     marked data-action (assets/mf-track.js counts no plp:to_plp for a link that does not navigate).
 * New here:
 *   - the letters are buttons, A-Z only (mf.mono.order: the store's alphabet). The catalogue's Á É Ö Ü CS GY NY SZ ZS
 *     and any other letter the designs carry are reached by typing, as in the live window (an input); a typed one
 *     outside A-Z shows as one more tile while it is the chosen letter. Once the designs are in, a letter with no
 *     design for this phone under the visitor's face lens (html.mf-g-women / mf-g-men, the same rule as the cards'
 *     data-g) is disabled;
 *   - the tiles are snippets/up-card.liquid's markup built from the endpoint's .dcard (name, picture, sale pill,
 *     1+1 chip on the 1+1 arm, data-g / data-p11 / data-mono / data-fs / data-mark) - no drop height: the cards
 *     endpoint does not carry the case type;
 *   - page 2 of the endpoint is asked together with page 1 (every phone probed on 2026-10-21 had 2-3 pages: one
 *     round trip less before the letters can be marked); the stylesheet (data-css) is added when the menu opens, or
 *     at the first opening (which waits for it, 900 ms at most) - a page whose menu never opens loads neither it
 *     nor any card.
 * Words: the store's own through window.mfT (snippets/mf-l10n.liquid): mono.*, and up.nav.n_designs_<form> (the count,
 * in the store language's CLDR plural form via Intl.PluralRules on <html lang>), up.nav.mono_with ("cu inițiala K"),
 * up.nav.mono_all_letter (the CTA on a letter), up.nav.p11_chip.
 */
(function () {
  'use strict';
  var W = window, D = document;
  var box = D.getElementById('mono');
  /* the store words, letter helpers and market paths come from snippets/mf-l10n.liquid (<head>); without them the
     window stays off and the Monogram links keep their own href (as live) */
  if (!box || W.mfOpenMonogram || !W.mfMonoLetter || !W.mfNormLetter || !W.mfHref) { return; }
  /* out of the header section: position fixed means the viewport, and the tiles count as the page's cards for
     assets/mf-track.js, as the old window's did */
  D.body.appendChild(box);

  function one(s) { return box.querySelector(s); }
  var abc = one('[data-mfm-abc]'), body = one('[data-mfm-body]'), results = one('[data-mfm-results]');
  var row = one('[data-mfm-row]'), status = one('[data-mfm-status]'), big = one('[data-mfm-big]');
  var count = one('[data-mfm-count]'), sub = one('[data-mfm-sub]'), devWrap = one('[data-mfm-dev]');
  var devName = one('[data-mfm-devname]'), all = one('[data-mfm-all]'), allL = one('[data-mfm-all-l]');
  var allText = allL ? allL.textContent : '';
  var suffix = box.getAttribute('data-mono-suffix') || '';
  var fallback = box.getAttribute('data-fallback') || '';
  var reduce = !!(W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var EXTRA = ['Á', 'É', 'Ö', 'Ü', 'CS', 'GY', 'NY', 'SZ', 'ZS'];   /* the catalogue's own letters: typed only */

  var cache = {};       /* device base -> Promise of [item] */
  var base = '';        /* the phone of this opening (href-ready) */
  var list = null;      /* the items of base, once loaded */
  var cur = '';         /* the chosen letter */
  var lastStep = '';
  var seq = 0;

  function step(name) {
    try { if (W.mfTrackPush) { W.mfTrackPush('mf_nav_step', { mf_step: ('mono:' + name).replace(/[^a-z0-9_:]/g, '_').slice(0, 40) }); } } catch (e) {}
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function face() {
    var c = D.documentElement.classList;
    return c.contains('mf-g-women') ? 'w' : c.contains('mf-g-men') ? 'm' : '';
  }
  /* the 1+1 chip follows the visitor's price arm (assets/up-search.js does the same for its JS-built cards) */
  function p11Arm() {
    /* the chip says 1+1: only on a 1+1 store (mf-store offer p11), never on a 2+2 one (multistore 2026-10-25) */
    if (W.__mfStore && W.__mfStore.offer && W.__mfStore.offer !== 'p11') return false;
    return W.__mfP11 ? W.__mfP11 === 'on' : D.documentElement.classList.contains('mf-p11-on');
  }
  function isOpen() { return box.classList.contains('u-on'); }

  /* ── the stylesheet: when the menu opens (the sheet is closed at first paint), or at the first opening ── */
  var cssP = null;
  function css() {
    if (cssP) { return cssP; }
    var href = box.getAttribute('data-css');
    cssP = new Promise(function (res) {
      if (!href) { res(); return; }
      var l = D.createElement('link');
      l.rel = 'stylesheet'; l.href = href;
      l.onload = l.onerror = function () { res(); };
      D.head.appendChild(l);
    });
    return cssP;
  }
  /* the menu is the way in: its opening fetches the sheet's stylesheet, so a page whose menu never opens loads none;
     the collection's Monogram pill (data-mfm-warm) fetches it on the pointer / focus before its tap */
  D.addEventListener('u:panel-open', function (e) { if (e.detail && e.detail.id === 'menu') { css(); } });
  function warm(e) { var t = e.target; if (t && t.closest && t.closest('[data-mfm-warm]')) { css(); } }
  D.addEventListener('pointerdown', warm, true);
  D.addEventListener('focusin', warm, true);

  /* ── the phone ── */
  /* href-ready (market-prefixed): the menu's device path, else the routes-built fallback; mfHref is idempotent */
  function deviceBase() {
    var b = '';
    try { b = W.mfMenuDeviceBase ? W.mfMenuDeviceBase() : ''; } catch (e) {}
    return W.mfHref(b || fallback);
  }
  function bare(p) {
    p = String(p || '').split('?')[0].split('#')[0].replace(/\/+$/, '');
    return W.mfPath ? W.mfPath(p) : p;
  }
  /* the name the device sheet shows for that phone (snippets/up-devices: the mockup's spelling) */
  function phoneName(b) {
    var want = bare(b);
    var rows = D.querySelectorAll('#devices a.mfd__devitem');
    for (var i = 0; i < rows.length; i++) {
      if (bare(rows[i].pathname || rows[i].getAttribute('href')) === want) { return String(rows[i].textContent || '').replace(/\s+/g, ' ').trim(); }
    }
    return '';
  }

  /* ── the designs (the live window's load, page 2 asked at once) ── */
  function viewUrl(b, page) {
    var u = W.mfHref(b + suffix);
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'view=mfcards&page=' + page;
  }
  function parse(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var meta = doc.getElementById('mfcards-meta');
    return { pages: meta ? (parseInt(meta.getAttribute('data-pages'), 10) || 1) : 1, cards: [].slice.call(doc.querySelectorAll('a.dcard')) };
  }
  function get(b, page) {
    return fetch(viewUrl(b, page), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) { throw new Error('mfcards ' + r.status); }
      return r.text();
    }).then(parse);
  }
  /* one entry of the old window's list, with what a tile needs */
  function item(c, letter, mark, mono) {
    var img = c.querySelector('.dcard__img img');
    var off = c.querySelector('.dbadge--sale');
    return {
      letter: letter, mark: mark, mono: mono,
      name: mark.replace(/\s*2\.0$/, ''),
      href: c.getAttribute('href') || '',
      g: c.getAttribute('data-g') || '',
      p11: c.getAttribute('data-p11') === '1',
      fs: c.getAttribute('data-fs') || '',
      src: img ? img.getAttribute('src') || '' : '',
      srcset: img ? img.getAttribute('srcset') || '' : '',
      alt: img ? img.getAttribute('alt') || '' : '',
      off: off ? String(off.textContent || '').trim() : ''
    };
  }
  function load(b) {
    if (cache[b]) { return cache[b]; }
    var p2 = get(b, 2);
    p2.catch(function () {});
    cache[b] = get(b, 1).then(function (first) {
      var more = [];
      if (first.pages >= 2) { more.push(p2); }
      for (var p = 3; p <= first.pages; p++) { more.push(get(b, p)); }
      return Promise.all(more).then(function (rest) {
        var seen = {}, out = [];
        [first].concat(rest).forEach(function (pg) {
          pg.cards.forEach(function (c) {
            var mk = c.querySelector('.dcard__mark');
            var mark = mk ? String(mk.textContent || '').trim() : '';
            /* "Coffee Cream - A 2.0 - device" (RO 2026-10-05 series): the name gives no letter; the card's data-mono
               (the second title part, rendered on the letter view) does, and it keeps the 35 letters of one series
               apart - the same key as the endpoint's dedupe */
            var mono = String(c.getAttribute('data-mono') || '').trim();
            var key = (mono ? mark + ' - ' + mono : mark).toLowerCase();
            if (!mark || seen[key]) { return; }
            seen[key] = 1;
            var letter = W.mfMonoLetter(mark, mono);
            if (letter) { out.push(item(c, letter, mark, mono)); }
          });
        });
        return out;
      });
    }).catch(function (err) { delete cache[b]; throw err; });
    return cache[b];
  }
  /* what the visitor sees: the face lens (the cards' data-g rule) and the Full-Shock-only PDP arm (data-fs="0",
     layout/theme.liquid) hide the same tiles here */
  function shown(x) {
    var f = face();
    if (f && x.g && x.g.indexOf(f) < 0) { return false; }
    if (x.fs === '0' && D.documentElement.classList.contains('mf-pdp-b')) { return false; }
    return true;
  }

  /* ── the letters ── */
  /* the tiles: the store's alphabet (A-Z on RO), plus the chosen letter when it was typed and is not one of them */
  function tileList() {
    var out = [], seen = {};
    function add(l) { l = W.mfNormLetter(l); if (l && !seen[l]) { seen[l] = 1; out.push(l); } }
    (W.MF_LETTER_ORDER || []).forEach(add);
    if (cur) { add(cur); }
    return out;
  }
  /* what a typed key may pick: the tiles, the catalogue's own letters, and any letter the designs carry */
  function letterList() {
    var out = [], seen = {};
    function add(l) { l = W.mfNormLetter(l); if (l && !seen[l]) { seen[l] = 1; out.push(l); } }
    (W.MF_LETTER_ORDER || []).forEach(add);
    EXTRA.forEach(add);
    if (list) { list.forEach(function (x) { add(x.letter); }); }
    return out;
  }
  var built = '';
  function build() {
    var ls = tileList(), sig = ls.join(' ');
    if (sig === built) { return; }
    built = sig;
    abc.innerHTML = ls.map(function (l) {
      return '<button type="button" class="u-mono-l" data-l="' + esc(l) + '" aria-pressed="' + (l === cur ? 'true' : 'false') + '"' +
        (l.length > 1 ? ' data-wide' : '') + '><span>' + esc(l) + '</span></button>';   /* the span takes text-box trimming (up-skin-mono.css) */
    }).join('');
  }
  /* once the designs are in: a letter with nothing to show is disabled (the chosen one stays usable) */
  function mark() {
    build();
    var n = {};
    if (list) { list.forEach(function (x) { if (shown(x)) { n[x.letter] = (n[x.letter] || 0) + 1; } }); }
    [].forEach.call(abc.children, function (b) {
      var l = b.getAttribute('data-l');
      b.disabled = !!list && !n[l] && l !== cur;
      b.setAttribute('aria-pressed', l === cur ? 'true' : 'false');
    });
  }
  function centre() {
    var b = abc.querySelector('[aria-pressed="true"]');
    if (!b || abc.scrollWidth <= abc.clientWidth) { return; }
    var x = b.offsetLeft - (abc.clientWidth - b.offsetWidth) / 2;
    try { abc.scrollTo({ left: Math.max(0, x), behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { abc.scrollLeft = Math.max(0, x); }
  }

  /* ── the result ── */
  /* "N designs" in the store language (ro: 1 design, 2-19 / 101-119 designuri, 20+ de designuri); an empty form
     falls back to _other */
  function plural(n) {
    var cat = n === 1 ? 'one' : 'other';
    try { cat = new Intl.PluralRules(D.documentElement.lang || 'ro').select(n); } catch (e) {}
    return (W.mfT('up.nav.n_designs_' + cat) || W.mfT('up.nav.n_designs_other')).replace(/\[n\]/g, String(n));
  }
  function show(msg) { status.textContent = msg || ''; status.hidden = !msg; }
  /* snippets/up-card.liquid, from the endpoint's card */
  function tile(x) {
    return '<a class="u-card" href="' + esc(x.href) + '" data-mark="' + esc(x.mark) + '" data-p11="' + (x.p11 ? 1 : 0) + '"' +
      (x.g ? ' data-g="' + esc(x.g) + '"' : '') + (x.mono ? ' data-mono="' + esc(x.mono) + '"' : '') +
      (x.fs === '0' ? ' data-fs="0"' : '') + ' data-mfm-pick>' +
      '<div class="u-hd"><div class="u-nm">' + esc(x.name) + '</div></div>' +
      '<div class="u-gloss u-nogloss u-matte">' + (x.src ? '<img src="' + esc(x.src) + '"' + (x.srcset ? ' srcset="' + esc(x.srcset) + '"' : '') +
        ' sizes="(min-width: 1100px) 190px, (min-width: 760px) 22vw, 42vw" alt="' + esc(x.alt) + '" width="500" height="750" loading="lazy">' : '') + '</div>' +
      '<div class="u-row">' + (x.off ? '<span class="u-off">' + esc(x.off) + '</span>' : '<span></span>') +
        (x.p11 && p11Arm() ? '<span class="u-chip" data-bf="off">' + esc(W.mfT('up.nav.p11_chip')) + '</span>' : '') + '</div></a>';
  }
  function skeleton() {
    var h = '';
    for (var i = 0; i < 6; i++) { h += '<span class="u-mono-sk" aria-hidden="true"></span>'; }
    row.innerHTML = h;
  }
  /* mono:letter_<x>, once per change; a typed letter waits a moment, so the C of a typed CS is not counted on its own
     (the old input waited 120 ms for the second character the same way) */
  var stepTimer = null;
  function letterStep(letter, wait) {
    clearTimeout(stepTimer);
    stepTimer = setTimeout(function () {
      if (letter !== cur) { return; }
      var s = 'letter_' + letter.toLowerCase().replace(/á/g, 'a2').replace(/é/g, 'e2').replace(/ö/g, 'o2').replace(/ü/g, 'u2');
      if (s !== lastStep) { lastStep = s; step(s); }
    }, wait);
  }
  function render(typed) {
    var letter = cur;
    box.classList.toggle('has-letter', !!letter);
    if (!letter) { results.hidden = true; row.innerHTML = ''; show(''); return; }
    results.hidden = false;
    big.textContent = letter;
    sub.textContent = ' ' + W.mfT('up.nav.mono_with', { letter: letter });   /* read out with the count; the Doto letter is the one on screen */
    var my = ++seq;
    if (!list) { skeleton(); count.textContent = W.mfT('mono.loading'); show(''); }
    load(base).then(function (l) {
      if (my !== seq) { return; }
      var hits = l.filter(function (x) { return x.letter === letter && shown(x); });
      row.innerHTML = hits.map(tile).join('');
      count.textContent = plural(hits.length);
      show(hits.length ? '' : W.mfT('mono.empty'));
      letterStep(letter, typed ? 450 : 0);
    }, function () {
      if (my !== seq) { return; }
      row.innerHTML = '';
      count.textContent = '';
      show(W.mfT('mono.error'));
    });
  }
  function pick(l, typed) {
    if (!l) { return; }
    var was = !!cur;
    cur = l;
    setAll();
    mark();
    render(typed);
    /* a phone folds the letters into one row: the chosen one in view, the result from its top */
    if (!was) { body.scrollTop = 0; }
    setTimeout(centre, 0);
  }

  /* ── open / close ── */
  function ready(p) {
    return Promise.race([p, new Promise(function (res) { setTimeout(res, 900); })]);
  }
  /* the CTA: the phone's Monogram view, on the chosen letter (the collection page preselects ?letter=) */
  function ctaHref() {
    var u = W.mfHref(base + suffix);
    return cur ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'letter=' + encodeURIComponent(cur) : u;
  }
  /* its href, and its label for what it opens: every letter, or with a letter "... cu K" (that letter, in the
     collection). When it targets the collection on screen, assets/up-lists.js re-renders that page in place: no
     navigation, so it carries data-action, the theme's "JS control" mark that assets/mf-track.js skips (no
     plp:to_plp for it, and the visitor's later exit still reads as left_warm / left_cold) */
  function setAll() {
    var h = ctaHref(), here = false;
    all.setAttribute('href', h);
    if (allL && allText) { allL.textContent = cur ? (W.mfT('up.nav.mono_all_letter', { letter: cur }) || allText) : allText; }
    try { here = !!D.querySelector('[data-u-coll]') && new URL(h, location.href).pathname === location.pathname; } catch (e) { here = false; }
    if (here) { all.setAttribute('data-action', 'mono-view'); } else { all.removeAttribute('data-action'); }
  }
  /* opts.base: the phone to list (the collection pill: the device page on screen); else the menu's phone */
  function open(opts) {
    var b = opts && typeof opts.base === 'string' && opts.base.charAt(0) === '/' ? W.mfHref(opts.base.split('?')[0]) : deviceBase();
    if (b !== base) { base = b; list = null; built = ''; }
    var nm = phoneName(base);
    devName.textContent = nm;
    devWrap.hidden = !nm;
    setAll();
    mark();
    step('open');
    var mine = base;
    load(base).then(function (l) {
      if (mine !== base) { return; }
      list = l; mark();
    }, function () {});
    if (cur) { render(); }
    /* the first opening can come before the stylesheet: wait for it a moment, never long */
    ready(css()).then(function () {
      if (W.upPanel) { W.upPanel.open('mono'); }
      else { box.classList.add('u-on'); box.setAttribute('aria-hidden', 'false'); }
      setTimeout(centre, 0);
    });
  }
  W.mfOpenMonogram = open;

  D.addEventListener('u:panel-close', function (e) {
    if (e.detail && e.detail.id === 'mono') { step('close'); }
  });
  /* the lens changed under the open sheet (another tab, the bfcache restore): the letters and tiles follow */
  D.addEventListener('mf:face-changed', function () { if (list) { mark(); if (cur && isOpen()) { render(); } } });

  box.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    if (t.closest('[data-mfm-close]') && !W.upPanel) { box.classList.remove('u-on'); box.setAttribute('aria-hidden', 'true'); step('close'); return; }
    var b = t.closest('.u-mono-l');
    if (b && abc.contains(b)) { if (!b.disabled) { pick(b.getAttribute('data-l')); } return; }
    if (t.closest('[data-mfm-pick]')) { step('pick'); return; }
    if (t.closest('[data-mfm-all]')) { step('all'); }
  });

  /* typing (desktop): a key picks its letter, folded by the store's mf.mono.fold (Ș -> S); two quick keys that make
     a letter of the list pick that one (C, S -> CS), as the old two-character input did. A key that folds to no
     letter of the list (ß -> SS) does nothing. AltGr counts as typing (the Romanian Programmers layout types ș with
     it; Windows reports AltGr as Ctrl+Alt); other Ctrl / Alt / Cmd chords are shortcuts and left alone */
  var LETTER = null;
  try { LETTER = new RegExp('^\\p{L}$', 'u'); } catch (eR) { LETTER = /^[A-Za-zÀ-ɏ]$/; }
  var MAC = /Mac|iP(hone|ad|od)/.test((W.navigator && (W.navigator.platform || W.navigator.userAgent)) || '');
  function chord(e) {
    if (e.metaKey) { return true; }
    if (!e.ctrlKey && !e.altKey) { return false; }
    var altGr = false;
    try { altGr = !!(e.getModifierState && e.getModifierState('AltGraph')); } catch (eM) {}
    return !(altGr || (!MAC && e.ctrlKey && e.altKey));
  }
  var kPrev = '', kAt = 0;
  D.addEventListener('keydown', function (e) {
    if (!isOpen() || e.defaultPrevented || chord(e) || !e.key || !LETTER.test(e.key)) { return; }
    var t = e.target;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable)) { return; }
    if (t && t.closest && !box.contains(t) && t !== D.body) { return; }   /* a popup above the sheet owns the keys */
    var k = W.mfNormLetter(e.key);
    if (!k) { return; }
    var now = new Date().getTime(), ls = letterList();
    var two = (kPrev && now - kAt < 900) ? kPrev + k : '';
    var l = (two && ls.indexOf(two) > -1) ? two : k;
    kPrev = k; kAt = now;
    if (ls.indexOf(l) < 0) { return; }
    e.preventDefault();
    pick(l, true);
  });
})();
